import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	headingNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase',
		defaultMessage: 'Accelerate teamwork 3× faster with video and AI, at {headingEmphasis}',
		description:
			'Header text for teamwork collection crossflow modal. The headingEmphasis placeholder is originally "no added cost"',
	},
	headingNoPriceIncreaseEmphasis: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.no.price.increase.emphasis.ai.powered',
		defaultMessage: 'no added cost',
		description: 'Emphasized text inside of the header when there is no price increase',
	},
	headingPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Default header text for teamwork collection crossflow modal when there is a price increase. The break placeholder originally says "video and AI-powered collaboration".',
	},
	headingJiraOnly: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.only',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Header text for teamwork collection crossflow modal when there is a price increase and the tenant has only Jira. The break placeholder originally says "AI-powered collaboration".',
	},
	headingJiraAndLoom: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.jira.and.loom',
		defaultMessage: 'Accelerate teamwork {headingEmphasis} with {break}',
		description:
			'Header text for teamwork collection crossflow modal when there is a price increase and the tenant has Jira and Loom. The break placeholder originally says "docs and AI-powered collaboration".',
	},
	headingPriceIncreaseEmphasis: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.price.increase.emphasis',
		defaultMessage: '3× faster',
		description: 'Emphasized text inside of the header when there is a price increase',
	},
	headingAIPowered: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.ai.powered',
		defaultMessage: 'AI-powered collaboration',
		description: 'Text where we want to break up the jira only heading',
	},
	headingVideo: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.video',
		defaultMessage: 'video and AI-powered collaboration',
		description: 'Text where we want to break up the default heading',
	},
	headingDocs: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.heading.docs',
		defaultMessage: 'docs and AI-powered collaboration',
		description: 'Text where we want to break up the default jira and loom heading',
	},
	closeModal: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.close',
		defaultMessage: 'Close modal',
		description: 'Close modal button label',
	},
	teamworkCollectionAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.alt',
		defaultMessage: 'Teamwork collection illustration',
		description: 'Alt text for teamwork collection illustration',
	},
	ctaWithPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaWithPaymentDetailsOnFile',
		defaultMessage: 'Agree and start trial',
		description: 'Confirmation button when there are payment details on file',
	},
	ctaNoPaymentDetailsOnFile: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.ctaNoPaymentDetailsOnFile',
		defaultMessage: 'Next',
		description: 'Confirmation button when there are no payment details on file',
	},
	trialTextStandardNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.noPriceIncrease',
		defaultMessage: '14-day free trial. After, your cost will {priceChange}.',
		description:
			'Subheading when opting into a Standard trial plan when there is no price increase',
	},
	trialTextPremiumNoPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.noPriceIncrease',
		defaultMessage: '30-day free trial. After, your cost will {priceChange}.',
		description: 'Subheading when opting into a Premium trial plan when there is no price increase',
	},
	priceChangeSame: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.same',
		defaultMessage: 'stay the same',
		description:
			'Text inside of the subheading for no price change when the price change is neutral',
	},
	priceChangeDecrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.noPriceIncrease.decrease',
		defaultMessage: 'decrease',
		description:
			'Text inside of the subheading for no price change when the price change is a decrease',
	},
	trialTextStandardPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.standard.priceIncrease',
		defaultMessage: '14-day free trial of Standard plan',
		description: 'Subheading when opting into a Standard trial plan when there is a price increase',
	},
	requestTrialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial',
		defaultMessage: 'Request approval from your admin to try Teamwork Collection',
		description: 'sub heading text that is shown to non-admins',
	},
	ctaRequestTrialText: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.cta.request.trial',
		defaultMessage: 'Request to try',
		description: 'cta text that is shown to non-admins to request a trial',
	},
	requestTrialComment: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.request.trial.comment',
		defaultMessage:
			'Teamwork Collection brings together Jira, Confluence, Loom, and Rovo so you can plan, document, and collaborate across teams—all in one place.',
		description: 'Request trial text sent as a notification to the admin',
	},
	trialTextPremiumPriceIncrease: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.trial.premium.priceIncrease',
		defaultMessage: '30-day free trial of Premium plan',
		description: 'Subheading when opting into a Premium trial plan when there is a price increase',
	},
	descriptionConfluence: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.confluence',
		defaultMessage: 'Create and collaborate on docs seamlessly',
		description: 'Describes the Confluence product',
	},
	descriptionRovo: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.rovo',
		defaultMessage: 'Easily find answers and create with AI',
		description: 'Describes the Rovo product',
	},
	descriptionLoomStandard: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.loom',
		defaultMessage: 'Save time by sharing videos your team can replay anytime',
		description: 'Describes the Loom product',
	},
	descriptionLoomPremium: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.description.loom',
		defaultMessage: 'Save time with AI-generated meeting notes and video',
		description: 'Describes the Loom product',
	},
	existingAppsHeader: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.existing.apps.header',
		defaultMessage: 'Bundled with your existing {appCount, plural, one {app} other {apps}}',
		description: 'Header above the list of existing apps',
	},
	visualAlt: {
		id: 'twc.xflow.modal.teamwork.collection.confirmation.screen.v2.visual.alt',
		defaultMessage: 'A graphic that displays Jira, Confluence, Confluence, and Loom integrations',
		description: 'Alternate text for a graphics about bundled apps',
	},
});
